import { render, staticRenderFns } from "./Migration.vue?vue&type=template&id=a6ae4db0&scoped=true&"
import script from "./Migration.vue?vue&type=script&lang=js&"
export * from "./Migration.vue?vue&type=script&lang=js&"
import style0 from "./Migration.vue?vue&type=style&index=0&id=a6ae4db0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ae4db0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
